import { useSelector } from 'react-redux';

const Captcha = () => {
  const setting = useSelector((state) => state.setting.data);

  if (!setting.isRecaptcha) {
    return null;
  }

  return (
    <div className="c7-google-recaptcha">
      This site is protected by reCAPTCHA Enterprise and the Google{' '}
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and{' '}
      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </div>
  );
};

export default Captcha;
